module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Tools/BrandParoc-0d5e6d54ced77a68a7b3cc1bf2bdc309.svg";